module.exports = __webpack_public_path__ + "static/scale-model-of-frontiers-of-flight-museum-in-dallas-texas-97e32bd89c9e0aad025424ab2122b3ca.png";